let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kiMhf")).then(() => parcelRequire('1IDq8'));